import { Injectable } from '@angular/core';
import {IEntity} from "../interfaces/ientity";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {map, Observable} from "rxjs";
import {BaseResponseDTO} from "../models/base-response-dto.model";
import {IPrimaryKey} from "../interfaces/iprimary-key";

@Injectable({
  providedIn: 'root'
})
export abstract class CrudBaseService<T extends IEntity> {

  protected constructor(protected http: HttpClient, protected rota: string) { }

  get baseUri(): string { return environment.apiUrl + this.rota; }

  getAllByUrlQuery<T>(urlQuery: string): Observable<BaseResponseDTO<T[]>> {
    return this.http.get<BaseResponseDTO<T[]>>(`${this.baseUri}/${urlQuery}`);
  }

  getByUrlQuery<T>(urlQuery: string): Observable<BaseResponseDTO<T>> {
    return this.http.get<BaseResponseDTO<T>>(`${this.baseUri}/${urlQuery}`);
  }

  getAll(): Observable<BaseResponseDTO<T[]>> {
    return this.http.get<BaseResponseDTO<T[]>>(this.baseUri);
  }

  get(id: IPrimaryKey<T>): Observable<BaseResponseDTO<T>> {
    return this.http.get<BaseResponseDTO<T>>(`${this.baseUri}/${this.getPk(id).id}`);
  }

  create(entity: T): Observable<BaseResponseDTO<T>> {
    return this.http.post<BaseResponseDTO<T>>(this.baseUri, entity);
  }

  createAllByRoute(route: string, entities: T[]): Observable<BaseResponseDTO<T[]>> {
    return this.http.post<BaseResponseDTO<T[]>>(`${this.baseUri}/${route}`, entities);
  }

  update(entity: T): Observable<BaseResponseDTO<T>> {
    return this.http.put<BaseResponseDTO<T>>(this.baseUri, entity);
  }

  delete(id: IPrimaryKey<T>): Observable<BaseResponseDTO<T>> {
    return this.http.delete<BaseResponseDTO<T>>(`${this.baseUri}/${this.getPk(id).id}`)
  }

  abstract getPk(id: IPrimaryKey<T>): IPrimaryKey<T>;
}
